<template>
  <div>
    <form @submit.prevent="submit">
      <div class="pl-2 pr-4 py-4">
        <div class="columns is-mobile is-variable is-1 is-vcentered">
          <div class="column is-narrow">
            <b-tooltip label="Kembali" type="is-dark">
              <button
                type="button"
                class="button is-white"
                @click="$router.go(-1)"
              >
                <b-icon icon="arrow-left"></b-icon>
              </button>
            </b-tooltip>
          </div>
          <div class="column">
            <h1 class="title is-5 has-text-weight-medium">
              {{ onEdit ? "Ubah" : "Tambah" }}
            </h1>
          </div>
          <div class="column is-narrow has-text-right">
            <b-button
              native-type="submit"
              type="is-primary"
              icon-left="check-bold"
            >
              Simpan
            </b-button>
          </div>
        </div>
      </div>

      <div class="p-4" style="max-width: 500px">
        <b-notification
          type="is-danger"
          aria-close-label="Tutup"
          role="alert"
          v-if="error"
          :closable="false"
        >
          {{ error | capitalize }}
        </b-notification>

        <b-field label="Pertanyaan *">
          <b-input v-model="title" required></b-input>
        </b-field>

        <b-field label="Jawaban Pertanyaan *">
          <b-input
            v-model="description"
            maxlength="200"
            type="textarea"
          ></b-input>
        </b-field>

        <b-field label="Status *">
          <b-switch v-model="isActive" type="is-success">
            Aktif
          </b-switch>
        </b-field>

        <br />

        <small>
          <i><span class="mr-2">*</span> : Wajib diisi</i>
        </small>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "QuestionForm",
  data() {
    return {
      error: "",
      id: this.$route.params.id,
      title: "",
      description: "",
      isActive: true
    };
  },
  methods: {
    loadQuestion() {
      const loadingComponent = this.$buefy.loading.open();

      this.$http({
        url: `questions/${this.id}`,
        method: "GET"
      })
        .then(async res => {
          const data = res.data.data;

          this.title = data.title;
          this.description = data.description;
          this.isActive = data.is_active;

          loadingComponent.close();
        })
        .catch(() => {
          loadingComponent.close();

          this.$buefy.snackbar.open({
            message: "Gagal memuat daftar Unit Kerja",
            type: "is-warning",
            duration: 5000,
            actionText: "Coba Lagi",
            onAction: () => {
              this.loadQuestion();
            }
          });
        });
    },
    submit() {
      this.error = "";
      const loadingComponent = this.$buefy.loading.open();

      const mode = this.getRequestProps({
        id: this.id,
        onEdit: this.onEdit,
        basePath: "questions",
        modelName: "Pertanyaan"
      });

      this.$http({
        url: mode.url,
        method: mode.method,
        data: {
          title: this.title,
          description: this.description,
          is_active: this.isActive
        }
      })
        .then(() => {
          this.$buefy.toast.open({
            message: `Berhasil ${mode.message} <i class="mdi mdi-check-bold has-text-success"></i>`
          });

          this.$router.push({ name: "question" });
          loadingComponent.close();
        })
        .catch(error => {
          loadingComponent.close();

          if (error.response.status === 400) {
            const errors = error.response.data.errors;
            this.error = errors[Object.keys(errors)[0]][0];
            return;
          }

          this.$buefy.snackbar.open({
            message: `Gagal ${mode.message}`,
            type: "is-warning",
            duration: 5000,
            actionText: "Retry",
            onAction: () => {
              this.submit();
            }
          });
        });
    }
  },
  computed: {
    onEdit() {
      return this.id;
    }
  },
  created() {
    if (this.onEdit) this.loadQuestion();
  }
};
</script>
